/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
};

const SvgComponent: FC<IProps> = ({ width = 24, height = 24 }) => (
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="General Icons">
      <path id="Vector" d="M21.5 15L18.414 11.914C18.0389 11.5391 17.5303 11.3284 17 11.3284C16.4697 11.3284 15.9611 11.5391 15.586 11.914L6.5 21M5.5 3H19.5C20.6046 3 21.5 3.89543 21.5 5V19C21.5 20.1046 20.6046 21 19.5 21H5.5C4.39543 21 3.5 20.1046 3.5 19V5C3.5 3.89543 4.39543 3 5.5 3ZM11.5 9C11.5 10.1046 10.6046 11 9.5 11C8.39543 11 7.5 10.1046 7.5 9C7.5 7.89543 8.39543 7 9.5 7C10.6046 7 11.5 7.89543 11.5 9Z" stroke="#262626" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </g>
  </svg>

);

export default SvgComponent;
